import { defineStore } from 'pinia'
import api from '@/services/api'

export const useUserStore = defineStore('userStore', {
  state: () => ({
    users: [],
    filecomponents: null,
    uploadedimage: null,
    loggedinuser: null,
    fieldjson: null,

  }),
  actions: {
    async fetchUsers() {
      // Replace with real API
      this.users = [
        {
          id: 'u1',
          name: 'Jane Smith',
          phone: '+1234567890',
          email: 'jane@example.com',
          registeredOn: 1716000000
        },
        {
          id: 'u2',
          name: 'Mike Johnson',
          phone: '+0987654321',
          email: 'mike@example.com',
          registeredOn: 1716100000
        }
      ]
    },
    async getloggedinuser(payload){
      const response =  await api.post('api/user/getloggedinuser',payload)
			this.loggedinuser = response.data.user
    },
    setfilecomponents(file){
      this.filecomponents = file
    },
    resetfilecomponents() {
      this.filecomponents = null
    },
    setfieldjson(file){
      this.fieldjson = file
    },
    resetfieldjson() {
      this.fieldjson = null
    },
    setuploadedimage(image) {
      this.uploadedimage = image
    }
  },
})
